import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';
import dayjs from 'dayjs';
import { CSVLink } from 'react-csv';
import Common from '../../Common';
import axios from 'axios';

const styles = () => ({
    csvButton:{
        justifyContent:'right',
        alignItems:'right',
        marginTop:'20px',
        display:'flex',
        marginRight:'100px'
    }
});

const CSVButton = withCookies((props) => {
    const {
        cookies,
        classes,
        allData,
    } = props;
    const [fetchDone, setFetchDone] = useState(false);
    const [date, setDate] = useState('');
    const [kubunName, setKubunName] = useState('');
    const [csvData, setCSVData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const fetchDoneRef = useRef(null);

    async function csvOutput(){
        try{
            if(allData.length <= 0){
                window.alert('出力するデータがありません。');
                return;
            }
            const res = window.confirm('CSV出力しますか？');
            if(res){
                const token = cookies.get('token');
                const jichitaiToken = cookies.get('x-jichitai-token');
                const jichitaiId = cookies.get('x-jichitai-jichitaiid');
                const header = await axios.get(
                    `${Common.apiServerUrl()}/api/search/header`,
                    {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'x-suppportcenter-token': token,
                            'x-jichitai-jichitaiid': jichitaiId,
                            'x-jichitai-token': jichitaiToken,
                        },
                        params: {},
                    }
                );
                setKubunName(allData[0].kubunName);

                //ヘッダー部分の格納（先頭のみに格納する）
                setHeaders(header.data.result);

                //現在時刻の取得（file名に現在時刻を入れるため）
                setDate(dayjs(new Date().toISOString()).format('YYYYMMDDHHmm'));

                //出力するデータをcsvDataに格納する
                setCSVData(allData);

                setFetchDone(true);

                fetchDoneRef && fetchDoneRef.current.link.click();
            }
        }
        catch (err) {
            console.log(err);
            window.alert('CSVデータの出力に失敗しました。');
        }
    }

    return (
        <React.Fragment>
            <Grid>
                <div className={classes.csvButton}>
                    <Button size={'large'} color='primary' variant='contained' onClick={() => csvOutput()}>{'CSV出力'}</Button>
                    {fetchDone && <CSVLink data={csvData} headers={headers} filename={`${kubunName}_${date}.csv`} ref={fetchDoneRef} />}
                </div>
            </Grid>
        </React.Fragment>
    );
});

CSVButton.propTypes = {
    classes: PropTypes.object.isRequired,
    allData: PropTypes.array.isRequired,
};

export default withStyles(styles)(CSVButton);